// excel-functions-utils JE SAMO ZA EXCEL FORMULE (KOJIH UGLAVNOM NEMA DIREKTNO U JAVASCRIPTU)
// 2024-12-19

/*
https://exceljet.net/functions

*/


// Excel NOT function
export const NOT = (logical) => { // FINAL
  // https://exceljet.net/functions/not-function
  // https://support.microsoft.com/en-us/office/not-function-9cfc6011-a054-40c7-a140-cd4ba2d87d77
  if (logical) {
    return false;
  } else {
    return true;
  }
};


// TODO treba da bude samo jedan argument obavezan ???
// AND(D8==="SVETLI OTVOR",C10==="VRATA SA REVIZIJOM")
// Excel AND function
export const AND = (condition1, condition2, ..._conditions_arr) => { // TODO
  // https://exceljet.net/functions/and-function
  /*
  The Excel AND function is a logical function used to test multiple conditions at the same time. AND returns TRUE only if all the conditions are met. If any conditions are not met, the AND function returns FALSE. The AND function is commonly used with other functions like IF, NOT, and OR to create complex logical tests.
  */
  // https://support.microsoft.com/en-us/office/and-function-5f19b2e8-e1df-4408-897a-ce285a19e9d9
  /*
  if (condition1 && condition2) {
    return true;
  } else {
    return false;
  }
  */
  if (_conditions_arr.length > 0 && condition1 && condition2) {
    let test = true; // test is initialy true
    for (let index = 0; index < _conditions_arr.length; index++) { //
      const condition = _conditions_arr[index];
      if (condition === true) {
        // do nothing
      } else {
        // If any conditions are not met, the AND function returns FALSE.
        test = false; //
        return false;
        break;
      }
    } // end of for
    return test;
  } else {
    if (condition1 && condition2) {
      return true;
    }
  }
  return false;
};


// TODO treba da bude samo jedan argument obavezan
// Excel OR function
export const OR = (condition1, condition2, ..._conditions_arr) => { // TODO
  // https://exceljet.net/functions/or-function
  /*
  The Excel OR function is a logical function used to test multiple conditions at the same time. OR returns TRUE if any condition is TRUE. If all conditions are FALSE, the OR function returns FALSE. The OR function is often used with the IF function and can be combined with NOT and AND to create complex logical tests.
  */
  // https://support.microsoft.com/en-us/office/or-function-7d17ad14-8700-4281-b308-00b131e22af0
  if (condition1 || condition2) {
    return true;
  }
  if (_conditions_arr.length > 0) {
    let bingo = false;
    for (let index = 0; index < _conditions_arr.length; index++) { //
      const condition = _conditions_arr[index];
      if (condition === true) {
        // bingo found
        bingo = true; //
        // returns TRUE if any condition is TRUE
        return true;
        break;
      }
    } // end of for
    return bingo;
  }
  return false;
};


// TODO
// Excel XOR function
const XOR = (condition1, condition2, ..._conditions_arr) => { // TODO
  // https://exceljet.net/functions/xor-function
  /*
  The XOR function performs what is called "exclusive OR". With two logical statements, XOR returns TRUE if either statement is TRUE, but returns FALSE if both statements are TRUE. If neither is TRUE, XOR also returns FALSE.
  */
  // https://support.microsoft.com/en-us/office/xor-function-1548d4c2-5e47-4f77-9a92-0533bba14f37
  // The XOR function returns a logical Exclusive Or of all arguments.

  if (condition1 || condition2) {
    if (condition1 && condition2) {
      return false;
    }
    return true;
  } else {
    return false;
  }
};


// Excel IF function
// NAPOMENA: nazvali smo je XIF umesto IF da ne bi došlo do zabune sa javascrit if petljom.
export const XIF = (condition, iftrue, iffalse) => { // FINAL
  if (condition) {
    return iftrue;
  }
  // if (iffalse || iffalse === 0 || iffalse === '') {
  /*
  https://developer.mozilla.org/en-US/docs/Glossary/Falsy
  null
  undefined.
  false	Boolean	The keyword false.
  NaN	Number	NaN — not a number.
  0	Number	The Number zero, also including 0.0, 0x0, etc.
  -0	Number	The Number negative zero, also including -0.0, -0x0, etc.
  0n	BigInt	The BigInt zero...
  ""	String
  */
  if (iffalse || iffalse === null || iffalse === NaN || iffalse === 0 || iffalse === -0 || iffalse === '') {
    return iffalse;
  } else {
    return false; // https://exceljet.net/functions/if-function
  }
};


// TODO
// Excel SWITCH function
// NAPOMENA: nazvali smo je bili XSWITCH umesto SWITCH da ne bi došlo do zabune sa javascrit switch petljom.
export const SWITCH = (value_expression, ..._pairs_arr) => { // TODO
  // https://exceljet.net/functions/switch-function
  // https://support.microsoft.com/en-us/office/switch-function-47ab33c0-28ce-4530-8a45-d532ec4aa25e
  /*
  The SWITCH function evaluates one value (called the expression) against a list of values, and returns the result corresponding to the first matching value. If there is no match, an optional default value may be returned.
  */
  let value_to_return;
  let bingo = false;
  if (_pairs_arr.length > 1) {
    for (let index = 0; index < _pairs_arr.length; index += 2) { // index 0, 2, 4, 6, 8 etc...
      const case_value_to_match = _pairs_arr[index];
      // const condition = value_expression === case_value_to_match;
      if (bingo === false && value_expression === case_value_to_match) {
        value_to_return = _pairs_arr[index + 1];
        // returns a result that corresponds to the first match found
        bingo = true; // prevent another bingo
        return value_to_return;
        break;
      }
    } // end of for
    if (bingo === true) {
      return value_to_return;
    } else {
      if (_pairs_arr.length % 2) { // number of parameters is odd
        // Default is the value to return in case no matches are found in the valueN expressions.
        const _default_value_to_return = _pairs_arr[_pairs_arr.length - 1]; // last argument is value to return in case no matches are found
        return _default_value_to_return;
      }
    }
  } else {
    // ERROR not enough arguments
  }
  return value_to_return;
};


// Excel IFS function
export const IFS = (..._pairs_arr) => {
  // Generally, the syntax for the IFS function is:
  // =IFS([Something is True1, Value if True1,Something is True2,Value if True2,Something is True3,Value if True3)
  //
  // https://exceljet.net/functions/ifs-function
  // https://support.microsoft.com/en-us/office/ifs-function-36329a26-37b2-467c-972b-4a39bd951d45
  let value_to_return;
  let bingo = false;
  for (let index = 0; index < _pairs_arr.length; index += 2) { // index 0, 2, 4, 6, 8 etc...
    const condition = _pairs_arr[index];
    if (bingo === false && condition === true) {
      // first bingo found - condition met first time
      value_to_return = _pairs_arr[index + 1];
      bingo = true; // prevent another bingo
      return value_to_return;
      break;
    }
  } // end of for
  return value_to_return;
};


// Excel ROUND function
export const ROUND = (number, num_digits) => {
  // TODO treba usavrsiti ovu funkciju
  // https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
  let n;
  let _num_digits = 0;
  if (num_digits > 0) {
    _num_digits = Math.floor(num_digits);
  }
  if (_num_digits === 0) {
    n = Math.round(number);
  } else {
    let multiplier = Math.pow(10, _num_digits)
    // n = Math.round((number) * multiplier) / multiplier;
    n = Math.round((number + Number.EPSILON) * multiplier) / multiplier;
  }
  // console.log('ROUND ', n);
  return n;
};


// Excel ROUNDUP function
export const ROUNDUP = (number, _num_digits) => {
  let num_digits = 0;
  if (_num_digits > 0) {
    num_digits = _num_digits;
  }
  /*
  // let nduzi = Number.parseFloat(number);
  // console.log('ROUNDUP', number, '  ', num_digits);
  let n = Number.parseFloat(Number.parseFloat(number).toFixed(num_digits));
  // console.log(Number.parseFloat(number), Number.parseFloat(number).toFixed(num_digits));
  if (Number.parseFloat(number) > n) {
    if (num_digits === 0) {
      // slucaj sa nula decimala
      n = Math.ceil(Number.parseFloat(number));
    } else {
      n += 1 / Math.pow(10, num_digits); // NISMO TESTIRALI
    }
  }
  // console.log('ROUNDUP ', n);
  // return n;
  */

  // NOVO oktobar 2021
  // https://stackoverflow.com/questions/4292678/function-to-roundup-as-microsoft-excel-does-in-javascript
  let piii = Number.parseFloat(number);
  /*
  for(var i = 0; i <= 11; i++) { 
    console.log((Math.ceil((piii*Math.pow(10, i)))/Math.pow(10,i)));
  }
  */
  let i = num_digits;
  let result = (Math.ceil((piii * Math.pow(10, i))) / Math.pow(10, i));
  // console.log('ROUNDUP ', piii, num_digits, result);
  return result;
};


// Excel ROUNDDOWN function
export const ROUNDDOWN = (number, num_digits) => {
  // let nduzi = Number.parseFloat(number);
  // console.log('ROUNDDOWN', number, '  ', num_digits);
  // for example number = 520.25 num_digits = 1
  let _num_digits = 0;
  if (num_digits > 0) { // minimum digits iz zero
    _num_digits = num_digits;
  }
  let n = Number.parseFloat(Number.parseFloat(number).toFixed(_num_digits));
  // console.log(Number.parseFloat(number), Number.parseFloat(number).toFixed(num_digits));
  if (Number.parseFloat(number) < n) {
    // for example 520.25 < 520.3
    if (_num_digits === 0) {
      // slucaj sa nula decimala
      n = Math.floor(Number.parseFloat(number));
    } else {
      let _number_string = Number.parseFloat(number).toFixed(num_digits);
      let _last_digit_number = Number.parseInt(_number_string.slice(-1));
      if (_num_digits === 1 && _last_digit_number === 1) {
        n = Math.floor(Number.parseFloat(number));
      } else {
        const _new_last_digit_number = _last_digit_number - 1;
        const _new_number_string = _number_string.slice(0, -1) + _new_last_digit_number;
        n = Number.parseFloat(_new_number_string);
      }
      //
      /*
      n -= 1 / Math.pow(10, _num_digits); // NISMO TESTIRALI
      
      GRESKA ROUNDDOWN(520.25, 1) gets you 520.1999999999999
      
      roundDown(4.56, 2) gives you 4.55, so I don't think it's a good solution. – 
      That's right, because 4.56 * 100 == 455.99999999999994 due to the internal floating point representation.
      */
    }
  }
  // console.log('ROUNDDOWN ', n);
  return n;
};


// Excel CEILING function
export const CEILING = (number, significance) => { // FINAL
  // https://exceljet.net/functions/ceiling-function
  // The Excel CEILING function rounds a given number up to the nearest specified multiple.
  // https://support.microsoft.com/en-us/office/ceiling-function-0a5cd7c8-0720-4f0a-bd2c-c943e510899f
  // Returns number rounded up, away from zero, to the nearest multiple of significance. For example, if you want to avoid using pennies in your prices and your product is priced at $4.42, use the formula =CEILING(4.42,0.05) to round prices up to the nearest nickel.
  //
  // https://stackoverflow.com/questions/49262842/excel-ceiling-function-in-javascript
  return Math.ceil(number / significance) * significance;
};


// Excel FLOOR function
export const FLOOR = (number, significance) => { // FINAL
  // https://exceljet.net/functions/floor-function
  // The Excel FLOOR function rounds a given number down to the nearest specified multiple.
  // https://support.microsoft.com/en-us/office/floor-function-14bb497c-24f2-4e04-b327-b0b4de5a8886
  // Rounds number down, toward zero, to the nearest multiple of significance.
  //
  // https://stackoverflow.com/questions/49262842/excel-ceiling-function-in-javascript
  return Math.floor(number / significance) * significance;
};


// Excel MOD function
export const MOD = (number, divisor) => { // FINAL
  // https://exceljet.net/functions/mod-function
  // The result of MOD carries the same sign as the divisor.
  // https://support.microsoft.com/en-us/office/mod-function-9b6cd169-b6ee-406a-a97b-edf2a9dc24f3
  //
  let remainder = number % divisor; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder
  if (divisor > 0 && remainder < 0) { // positive divisor
    remainder = -1 * remainder;
  }
  if (divisor < 0 && remainder > 0) { // negative divisor
    remainder = -1 * remainder;
  }
  return remainder;
};


// Excel INT function
export const INT = (number) => { // FINAL
  // https://exceljet.net/functions/int-function
  // The Excel INT function returns the integer part of a decimal number by rounding down to the integer. Note that negative numbers become more negative. For example, while INT(10.8) returns 10, INT(-10.8) returns -11.
  // https://support.microsoft.com/en-us/office/int-function-a6c4af9e-356d-4369-ab6a-cb1fd9d343ef
  // Rounds a number down to the nearest integer.
  // =INT(8.9) // Rounds 8.9 down to 8
  // =INT(8.9) // Rounds 8.9 down to 8
  // 
  // https://stackoverflow.com/questions/55441781/execl-int-for-javascript
  return Math.floor(number);
  // const n = Math.floor(number);
  // return n;
};


// Excel SDRT function
export const SQRT = (number) => { return Math.sqrt(number); }; // FINAL


// Excel PI function
export const PI = () => { return Math.PI }; // FINAL


// Excel SIN function
export const SIN = (radians) => {
  /*
  The SIN function syntax has the following arguments:
  
  Number    Required. The angle in radians for which you want the sine.
  
  Remark
  If your argument is in degrees, multiply it by PI()/180 or use the RADIANS function to convert it to radians.
  */
  const sin = Math.sin(radians); // argument: A number representing an angle in radians.
  return sin;
};


/*
Excel > Function reference > Math and trigonometry
ROUNDUP
Show AllShow All
Hide AllHide All
Rounds a number up, away from 0 (zero).

Syntax

ROUNDUP(number,num_digits)

Number   is any real number that you want rounded up.

Num_digits   is the number of digits to which you want to round number.

Remarks

ROUNDUP behaves like ROUND, except that it always rounds a number up. 
If num_digits is greater than 0 (zero), then number is rounded up to the specified number of decimal places.

If num_digits is 0, then number is rounded up to the nearest integer.

If num_digits is less than 0, then number is rounded up to the left of the decimal point.
Example

The example may be easier to understand if you copy it to a blank worksheet.

ShowHow to copy an example

Create a blank workbook or worksheet.
Select the example in the Help topic. 
 Note    Do not select the row or column headers.

Selecting an example from Help

Selecting an example from Help
Press CTRL+C.
In the worksheet, select cell A1, and press CTRL+V.
To switch between viewing the results and viewing the formulas that return the results, press CTRL+` (grave accent), or on the Formulas tab, in the Formula Auditing group, click the Show Formulas button.
   
1 
2 
3 
4 
5 
6 
 A B 
Formula Description (Result) 
=ROUNDUP(3.2,0) Rounds 3.2 up to zero decimal places (4) 
=ROUNDUP(76.9,0) Rounds 76.9 up to zero decimal places (77) 
=ROUNDUP(3.14159, 3) Rounds 3.14159 up to three decimal places (3.142) 
=ROUNDUP(-3.14159, 1) Rounds -3.14159 up to one decimal place (-3.2) 
=ROUNDUP(31415.92654, -2) Rounds 31415.92654 up to 2 decimal places to the left of the decimal (31500) 
 



See Also
CEILING
FLOOR
INT
Math and trigonometry functions
MOD
MROUND
ROUND
Round a number
ROUNDDOWN
TRUNC
*/

